import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { GEO_REGION } from "../apiRoutes";

interface GeoRegionResponse {
  data: any;
}

const fetchGeoRegionDetail = async (id: string) => {
  const response = await axiosAuth.get<GeoRegionResponse>(
    `${GEO_REGION}${id}`
  );
  return response.data;
};

const useGetGeoRegionDetailQuery = (
  id?: string,
  queryParams?: UseQueryOptions<any, Error, any, ["geoRegionDetail", string | undefined]>
) =>
  useQuery<any, Error, any, ["geoRegionDetail", string | undefined]>({
    queryKey: ["geoRegionDetail", id],
    queryFn: () => fetchGeoRegionDetail(String(id)),
    enabled: Boolean(id),
    ...(queryParams as any),
  });

export default useGetGeoRegionDetailQuery;


